import { imageAssetUrl } from "@/utils/url";
import { Client } from "creso-core/types";
import { CreateGoal } from "./create-goal";

export function GoalsEmpty({ client }: { client: Client }) {
  return (
    <div className="flex-1 rounded-lg gap-20 bg-card border border-border flex items-center w-full">
      <div className="flex-1 items-center justify-center flex flex-col">
        <div className="flex flex-col items-start">
          <span className="text-xl font-semibold">Goals</span>
          <span className="mt-2 mb-12 text-muted-foreground">
            Align client’s interests and track them easily
          </span>
          <CreateGoal client={client} label="Create Goal" />
        </div>
      </div>
      <div className="flex-1 items-center justify-start flex">
        <div className="h-50 w-70 bg-card">
          <img src={imageAssetUrl("/proposals/goals-empty.png")} />
        </div>
      </div>
    </div>
  );
}
